import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, ChangeDetectorRef, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'

import {  KhoaHocs_KhoaHoc } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { EmitType, detach } from '@syncfusion/ej2-base';
import { UploaderComponent, RemovingEventArgs, SelectedEventArgs, SuccessEventArgs, FileInfo } from '@syncfusion/ej2-angular-inputs';

import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import { SelectionService, EditService, SelectionSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FileManagerComponent, FileOpenEventArgs, FileSelectEventArgs } from '@syncfusion/ej2-angular-filemanager';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';

const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-lophocedit',
  templateUrl: './lophocedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./lophocedit.component.scss'],
  providers: [ListService, Repository, WindowRef, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService],
  encapsulation: ViewEncapsulation.None
})


export class lophoceditComponent implements OnInit {

  @ViewChild('mdDanhSachLichHoc') mdDanhSachLichHoc: BsModalComponent;
  @ViewChild('dtedslichhocedit') dtedslichhocedit: any;
  activeTab: string = 'thongtin'; 
  dviid: string;
  inputhinhthucdaotaos: any = [];
  inputchungchis: any = [];
  inputGiangViens: any;
  items = [];
  donviitems = [];
  datas = [];
  dskhoilops: any;
  inputphanloais = [{ Id: 0, Ten: 'Dài hạn' }, { Id: 2, Ten: 'Trực tuyến' }, { Id: 1, Ten: 'Không thường xuyên' }
  ];
  inputtinhtrangs = [{ Id: 0, Ten: 'Dự kiến' }, { Id: 1, Ten: 'Chính thức' }
  ];
  dsCachTinhHocPhis = [
    { Id: 1, Ten: 'Tính theo buổi thu sau' },
    { Id: 6, Ten: 'Tính theo buổi thu trước' },
    { Id: 2, Ten: 'Tính theo tháng' },   
    { Id: 3, Ten: 'Tính theo gói' },
    { Id: 4, Ten: 'Tính tự do' },
    { Id: 5, Ten: 'Thu tiền theo từng buổi' }]
  dsChuyKys = [
    { Id: 2, Ten: 'Thu theo tháng' },
    { Id: 1, Ten: 'Thu theo buổi' },
  ]
  motNgayChiTinhMotCaChecked: boolean = false;

  // Weekly schedule data
  weeklySchedule: any[] = [
    { dayId: 2, dayName: 'Thứ Hai', isActive: false, schedules: [] },
    { dayId: 3, dayName: 'Thứ Ba', isActive: false, schedules: [] },
    { dayId: 4, dayName: 'Thứ Tư', isActive: false, schedules: [] },
    { dayId: 5, dayName: 'Thứ Năm', isActive: false, schedules: [] },
    { dayId: 6, dayName: 'Thứ Sáu', isActive: false, schedules: [] },
    { dayId: 7, dayName: 'Thứ Bảy', isActive: false, schedules: [] },
    { dayId: 8, dayName: 'Chủ Nhật', isActive: false, schedules: [] }
  ];

  // Student list
  danhSachHocVien: any[] = []; 

  // Available study sessions
  availableCaHocs: any[] = [];

  inputphonghocs: any;

  dsCachGuiThongBaos = [
    { id: 1, ten: 'Gửi vào ngày cố định' },
    { id: 2, ten: 'Gửi theo số buổi còn lại' },
    { id: 3, ten: 'Gửi thông báo khi hết khóa' }
  ];

  inputtaikhoannganhangs: any = [];

  private hostUrl: string = '/';
  // upload
  @ViewChild('uploadObj')
  public uploadObj: UploaderComponent;
  @ViewChild('dialogObj')
  public dialogObj: DialogComponent;
  @ViewChild('filemanagerObj')
  public filemanagerObj: FileManagerComponent;
  public dialogHeader = 'Chọn tệp ảnh';
  public animationSettings: Object = { effect: 'None' };
  public showCloseIcon = true;
  public target = '#target';
  public visible = false;
  public dialogWidth = '850px';
  public contextmenuItems: string[] = ['Open', '|', 'Cut', 'Copy', 'Delete', 'Rename', '|', 'Details'];
  ajaxSettings = {
    url: this.hostUrl + 'FileUpLoadManager/FileOperations',
    getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
    uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
    downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
  };
  public btnClick: EmitType<object> = () => {
    //if (document.getElementById('target').classList.contains('upload-dialog1')) {
    //  document.getElementById('target').classList.remove('upload-dialog1');
    //}
    //document.getElementById('target').classList.add('upload-dialog');
    this.dialogObj.show();
    this.dialogOpen();
    this.filemanagerObj.path = '/';
    this.filemanagerObj.selectedItems = [];
    this.filemanagerObj.refresh();
  }

  // Uploader will be hidden, if Dialog is opened
  public dialogOpen: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'none';
  }
  // Uploader will be shown, if Dialog is closed
  public dialogClose: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'block';
  }
  OnbeforeSend(args) {

    var data = JSON.parse(args.ajaxSettings.data);
    if (args.action == 'Upload') {
      //data[0]["CodeClass"] = this.codeClass;
      //data[0]["Loai"] = 1;
      data.push({ codeclass: 'ThuVien' });
      data.push({ PathFolder: "~/Upload/ThuVien" });
      data.push({ loai: 1 });
      args.ajaxSettings.data = JSON.stringify(data);
    }
    else {
      data["CodeClass"] = 'ThuVien';
      data["DonVi"] = null;
      data["PathFolder"] = "~/Upload/ThuVien";
      data["Loai"] = 1;
      args.ajaxSettings.data = JSON.stringify(data);
    }

  };
  // File Manager's fileOpen event function
  public onFileOpen(args: FileOpenEventArgs): void {
    let file = (args as any).fileDetails;
    if (file.isFile) {
      args.cancel = true;
      if (file.size <= 0) { file.size = 10000; }
      this.uploadObj.files = [{ name: file.name, size: file.size, type: file.type }];
      // let filterPath = "/Content/Files" + file.filterPath.replace('\\', '/') + file.name;
      let filterPath = '/Upload/ThuVien' + '/' + file.filterPath.replace('\\', '/').replace('\\', '/').replace('\\', '/').replace('\\', '/') + '/' + file.name;
      this.doituongSelect.DuongDanAnh = filterPath;
      this.dialogObj.hide();
      //if (document.getElementById('target').classList.contains('upload-dialog')) {
      //  document.getElementById('target').classList.remove('upload-dialog');
      //}
      //document.getElementById('target').classList.add('upload-dialog1');

    }
  }
  public ngOnDestroy(): void {
    if (this.scheduleChangeTimeout) {
      clearTimeout(this.scheduleChangeTimeout);
    }

    if (document.getElementById('target').classList.contains('upload-dialog')) {
      document.getElementById('target').classList.remove('upload-dialog');
    }
  }

  toolbarSettings = {
    items: ['NewFolder', 'Upload', 'Delete', 'Cut', 'Copy', 'Rename', 'SortBy', 'Refresh', 'Selection', 'View', 'Details']
  };
  contextMenuSettings = {
    file: this.contextmenuItems,
    folder: this.contextmenuItems
  };
  taifile(src: string) {
    console.log(src);
    window.location.href = src;
  }
  deleteFile() {
    this.doituongSelect.DuongDanAnh = null;
  }

  // upload




  alertMsg: any;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileUpLoadManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
      uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
      downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
    }
  };


  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public width: string = '98%';
  // public animationSettings: AnimationSettingsModel = { effect: 'None' };
  // public target: string = '.control-section';
  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;


  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  // Add this method to handle CachTinhHocPhi changes
  onCachTinhHocPhiChange(): void {
    if (this.doituongSelect.CachTinhHocPhi !== 6) {
      this.doituongSelect.ChuKyThu = null;
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }
  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    } else {
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);

    }
  }



  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
   bledit: boolean = false;
  currentUser: any;
  dschinhanhs: any;
  dschuongtrinhs: any;

  doituongSelect: any = {
    Id: null, Ten: null, TuNgay_S: null, DenNgay_S: null, Ma: null,
    TuNgay: null, DenNgay: null, GiangVien: null, DonViId: null, BoPhanId: null,
    HinhThucDaoTaoId: null, ChungChiId: null, ChiPhiDaoTao_CT: null, TongChiPhi_CT:null,
    HangMucId: null, ImageUrl: '/Content/images/course-doc.png',
    CachGuiThongBao: null,
    DieuKienGui: null,
    Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , TrangThai: null
    , TrangThai2: null, PhanLoai: null, DoTuoi: null, ChuongTrinhHocId: null
    , ViTri: null, SiSo: null, TinhTrang: null, SoBuoi: null, PhongHocId: null, NguoiHoTro: null
    , NguoiChamSoc: null, TroGiang1: null, TroGiang2: null, ThoiGianHoc: null
    , AutoHocPhi: null
    , MotNgayChiTinhMotCa: null, KhoiLopId: null, SoTienAnCa: null, BankId: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };


  constructor(private _dataService: ListService, public repo: Repository, private cdr: ChangeDetectorRef) {


  }

  ngOnInit(): void {
   
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    this.activeTab = 'thongtin';
  }
  onMotNgayChiTinhMotCaChange(checked: boolean): void {
    this.doituongSelect.MotNgayChiTinhMotCa = checked ? 1 : 0;
  }
  isLoadingHocVien: boolean = false;
  // Add method to handle tab switching with event prevention
  setActiveTab(tabName: string, event?: Event): void {
    // Prevent default anchor behavior
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.activeTab = tabName;

    // Optional: Load data when switching to specific tabs
    switch (tabName) {
      case 'lichhoc':
        // Refresh schedule data if needed
        if (this.doituongSelect.Id) {
          this.loadLichHoc();
        }
        break;
      case 'hocvien':
        // Refresh student data if needed
        if (this.doituongSelect.Id) {
          this.isLoadingHocVien = true;
          this.loadHocVienData();
          this.refreshCaHocList();
        }
        break;
    }
  }
  switchToTab(tabName: string): void {
    this.setActiveTab(tabName);
  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  public changeChiNhanh($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.DonViId = null;
      
    }
    else {
      this.doituongSelect.DonViId = $event.Id;
      this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.doituongSelect.DonViId })
        .subscribe(response => {
          this.inputGiangViens = response;
        });
    }
  }
  loadDataInit(nhomdoituongid: string, id: string, donviid: string,tenlop:string) {
    this.activeTab = 'thongtin';
    this.dviid = donviid;
    this.repo.postRequest('api/banktransaction/getbanklist', { DonViId: this.dviid })
      .subscribe(response => {
        if (response && response.Success) {
          this.inputtaikhoannganhangs = response.Data;
        }
      });
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

      this.repo.getRequest("api/hoso/combohangmuc/")
        .subscribe(response => {
          this.items = response;

        });
      this.repo.getRequest("api/hoso/donvicaylist/", { phanloaiId: -1, giaithe: 1 })
        .subscribe(response => {
          this.donviitems = response;

        });
      this.repo.getRequest("api/hocvien/getcombophonghoc/", { donviid: this.dviid })
        .subscribe(response => {
          this.inputphonghocs = response.data;

        });
          
      this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.dviid})
        .subscribe(response => {
          this.inputGiangViens = response;
        });
      this.repo.getRequest("api/hoso/conmonlist/", { entityName: 'DM_HinhThucDaoTao' })
        .subscribe(response => {
          this.inputhinhthucdaotaos = response;
        });
      this.repo.getRequest("api/hoso/combochungchi/")
        .subscribe(response => {
          this.inputchungchis = response;
        });

    

      this.repo.postRequest('api/login/gettrungtams', { UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.dschinhanhs = response;
        });

      this.repo.postRequest('api/hoso/combokhoihoc', { UserName: this.currentUser.user_name, DonViId: this.dviid })
        .subscribe(response => {
          this.dskhoilops = response;

        });


    }
    //setTimeout(() => {
    //  this.mafocus.nativeElement.focus();
    //}, 500);

    this.doituongSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");


    this.doituongSelect = {
      Id: null, Ten: null, TuNgay_S: null, DenNgay_S: null, Ma: null,
      TuNgay: null, DenNgay: null, GiangVien: null, DonViId: this.dviid, BoPhanId: null,
      HinhThucDaoTaoId: null, ChungChiId: null,
      CachGuiThongBao: null,
      DieuKienGui: null,
      HangMucId: null, ImageUrl: '/Content/images/course-doc.png',
      Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , TrangThai: null
      , ChiPhiDaoTao_CT: null, TongChiPhi_CT:null
      //, ChiTiets: []
      //, LichHocs: []
      , TrangThai2: null, PhanLoai: null, DoTuoi: null, ChuongTrinhHocId: null
    , ViTri: null, SiSo: null, TinhTrang: null, SoBuoi: null, PhongHocId: null, NguoiHoTro: null
      , NguoiChamSoc: null, TroGiang1: null, TroGiang2: null, ThoiGianHoc: null
      , AnhString: null, MoTa: null, KhoiLopId: null, SoTienAnCa: null, BankId: null

    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;
    if (id === null) {

      this.doituongSelect.TrangThai = false;
      this.bledit = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      this.doituongSelect.PhanLoai = 0;
      this.doituongSelect.TinhTrang = 1;
      this.doituongSelect.TrangThai = 1;
      this.doituongSelect.TrangThai2 = true;
      this.doituongSelect.Ten = tenlop;

      this.doituongSelect.AutoHocPhi = 0;
      this.autoHocPhiChecked = false;

      this.doituongSelect.MotNgayChiTinhMotCa = 0;
      this.doituongSelect.IsTronThang = 0;
      this.motNgayChiTinhMotCaChecked = false;
      this.isTronThangChecked = false;

      this.resetWeeklySchedule();

      this.repo.postRequest("api/daotao/getthongtinhoso/", { id: null, status: this.dviid })
        .subscribe(response => {
          this.doituongSelect.Ma = response.MaLop;
        });
      this.loadAvailableCaHocs();
      //setTimeout(() => {
      //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      //  this.rteObj.toolbarModule.refreshToolbarOverflow();
      //}, 400);
    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.postRequest("api/daotao/getthongtinhoso/", { id: id, status: 0 })
        .subscribe(response => {
          this.doituongSelect.Id = id;
          console.log(response.ThongTin[0]);
          this.doituongSelect.Ma = response.MaLop;
          if (response.ThongTin !== null && response.ThongTin !== undefined && response.ThongTin.length > 0) {
            this.doituongSelect.Id = response.ThongTin[0].Id;
            this.doituongSelect.Ten = response.ThongTin[0].Ten;
            this.doituongSelect.Ma = response.ThongTin[0].Ma;
            this.doituongSelect.HangMucId = response.ThongTin[0].HangMucId;
            this.doituongSelect.ChungChiId = response.ThongTin[0].ChungChiId;
            this.doituongSelect.HinhThucDaoTaoId = response.ThongTin[0].HinhThucDaoTaoId;
            if (response.ThongTin[0].TuNgay!==null)
              this.doituongSelect.TuNgay = new Date(response.ThongTin[0].TuNgay);
            if (response.ThongTin[0].DenNgay !== null)
            this.doituongSelect.DenNgay = new Date(response.ThongTin[0].DenNgay);
            this.doituongSelect.TuNgay_S = response.ThongTin[0].TuNgay_S;
            this.doituongSelect.DenNgay_S = response.ThongTin[0].DenNgay_S;
            this.doituongSelect.MoTa = response.ThongTin[0].MoTa;
            this.doituongSelect.ImageUrl = response.ThongTin[0].ImageUrl;

            this.doituongSelect.AutoHocPhi = response.ThongTin[0].AutoHocPhi;
            this.autoHocPhiChecked = response.ThongTin[0].AutoHocPhi === 1;

            this.doituongSelect.TrangThai2 = response.ThongTin[0].TrangThai2;
            this.doituongSelect.TrangThai = response.ThongTin[0].TrangThai;
            this.doituongSelect.PhanLoai = response.ThongTin[0].PhanLoai;
            this.doituongSelect.DoTuoi = response.ThongTin[0].DoTuoi;
            this.doituongSelect.ChuongTrinhHocId = response.ThongTin[0].ChuongTrinhHocId;
            this.doituongSelect.ViTri = response.ThongTin[0].ViTri;
            this.doituongSelect.SiSo = response.ThongTin[0].SiSo;
            this.doituongSelect.TinhTrang = response.ThongTin[0].TinhTrang;
            this.doituongSelect.SoBuoi = response.ThongTin[0].SoBuoi;
            this.doituongSelect.PhongHocId = response.ThongTin[0].PhongHocId;
            this.doituongSelect.NguoiHoTro = response.ThongTin[0].NguoiHoTro;
            this.doituongSelect.NguoiChamSoc = response.ThongTin[0].NguoiChamSoc;
            this.doituongSelect.TroGiang1 = response.ThongTin[0].TroGiang1;
            this.doituongSelect.TroGiang2 = response.ThongTin[0].TroGiang2;
            this.doituongSelect.ThoiGianHoc = response.ThongTin[0].ThoiGianHoc;
            this.doituongSelect.GiangVien = response.ThongTin[0].GiangVien;
            this.doituongSelect.ChiPhiDaoTao_CT = response.ThongTin[0].ChiPhiDaoTao_CT;
            this.doituongSelect.TongChiPhi_CT = response.ThongTin[0].TongChiPhi_CT;
            this.doituongSelect.CachTinhHocPhi = response.ThongTin[0].CachTinhHocPhi;
            
            this.doituongSelect.ChuKyThu = response.ThongTin[0].ChuKyThu;
            this.doituongSelect.CachGuiThongBao = response.ThongTin[0].CachGuiThongBao;
            this.doituongSelect.DieuKienGui = response.ThongTin[0].DieuKienGui;

            this.doituongSelect.MotNgayChiTinhMotCa = response.ThongTin[0].MotNgayChiTinhMotCa;
            
            this.motNgayChiTinhMotCaChecked = response.ThongTin[0].MotNgayChiTinhMotCa === 1; 
            this.doituongSelect.IsTronThang = response.ThongTin[0].IsTronThang;
            this.isTronThangChecked = response.ThongTin[0].IsTronThang === 1;
            this.doituongSelect.KhoiLopId = response.ThongTin[0].KhoiLopId;
            this.doituongSelect.SoTienAnCa = response.ThongTin[0].SoTienAnCa;
            this.doituongSelect.BankId = response.ThongTin[0].BankId;
            

          }

          // Load danh sách lịch học nếu có trong response
          if (response.LichHocs && response.LichHocs.length > 0) {
            console.log("Loading schedule data...", response.LichHocs);
            this.loadLichHocFromResponse(response.LichHocs);
          } else {
            // Nếu không có trong response, reset lịch học
            this.resetWeeklySchedule();
          }

          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;

          this.loadAvailableCaHocs();

          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);

        });
    }



  }
  // Thêm method để reset lịch học
  private resetWeeklySchedule(): void {
    this.weeklySchedule.forEach(day => {
      day.isActive = false;
      day.schedules = [];
    });
  }
  public isTronThangChecked: boolean = false;

  // Add this method to handle the change event
  onIsTronThangChange(value: boolean): void {
    this.isTronThangChecked = value;
    // Add any additional logic needed when this option changes
    if (this.doituongSelect) {
      this.doituongSelect.IsTronThang = value?1:0;
    }
  }
  // Thêm method để load lịch học từ response
  private loadLichHocFromResponse(lichHocData: any[]): void {
    // Reset schedule trước
    this.resetWeeklySchedule();

    // Group data by day
    lichHocData.forEach(item => {
      const day = this.weeklySchedule.find(d => d.dayId === item.Thu);
      if (day) {
        day.isActive = true;

        // Tạo Date object từ thời gian
        const tuGio = item.TuGio ? this.createTimeDate(item.TuGio) :
          item.TuNgay ? new Date(item.TuNgay) : null;
        const denGio = item.DenGio ? this.createTimeDate(item.DenGio) :
          item.DenNgay ? new Date(item.DenNgay) : null;

        day.schedules.push({
          Id: item.Id,
          tuGio: tuGio,
          denGio: denGio,
          giaTien1Ca: item.giaTien1Ca || null, 
          phongHocId: item.PhongHocId,
          giaoVienId: item.GiaoVienId,
          ghiChu: item.GhiChu || ''
        });
      }
    });
  }

  // Helper method để tạo Date object từ string thời gian
  private createTimeDate(timeString: string): Date {
    if (!timeString) return null;

    // Nếu timeString là định dạng HH:mm 
    if (timeString.includes(':') && timeString.length <= 5) {
      const timeParts = timeString.split(':');
      if (timeParts.length === 2) {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate(),
          parseInt(timeParts[0]), parseInt(timeParts[1]), 0);
      }
    }

    // Nếu timeString là DateTime string, parse trực tiếp
    return new Date(timeString);
  }
  // Helper property for checkbox binding
  autoHocPhiChecked: boolean = false;

  // Method to handle checkbox change
  onAutoHocPhiChange(checked: boolean): void {
    this.doituongSelect.AutoHocPhi = checked ? 1 : 0;
  }
  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Id == null)
      this.doituongSelect.Id = 0;

    if (this.doituongSelect.GiangVien === null || this.doituongSelect.GiangVien === '') {
      swal('Cảnh báo!', "Bạn chưa chọn giảng viên!!!", 'warning');
      return;
    }

    if (this.doituongSelect.Tu_Ngay != null)
      this.doituongSelect.Tu_NgayS = this.doituongSelect.Tu_Ngay.getDate() + '/' + (this.doituongSelect.Tu_Ngay.getMonth() + 1) + '/' + this.doituongSelect.Tu_Ngay.getFullYear() + '/' + this.doituongSelect.Tu_Ngay.getHours() + '/' + this.doituongSelect.Tu_Ngay.getMinutes() + '/' + this.doituongSelect.Tu_Ngay.getSeconds();
    else
      this.doituongSelect.Tu_NgayS = null;

    if (this.doituongSelect.Den_Ngay != null)
      this.doituongSelect.Den_NgayS = this.doituongSelect.Den_Ngay.getDate() + '/' + (this.doituongSelect.Den_Ngay.getMonth() + 1) + '/' + this.doituongSelect.Den_Ngay.getFullYear() + '/' + this.doituongSelect.Den_Ngay.getHours() + '/' + this.doituongSelect.Den_Ngay.getMinutes() + '/' + this.doituongSelect.Den_Ngay.getSeconds();
    else
      this.doituongSelect.Den_NgayS = null;

    // this.doituongSelect.ImageUrl = picId.src;
    this.doituongSelect.DonViId = this.dviid;

    // Lưu thông tin lớp học trước
    this.repo.postRequest("api/daotao/addorupdate", this.doituongSelect)
      .subscribe(response => {
        if (response.Status === "OK") {
          this.doituongSelect.Id = response.Data;

          // Sau khi lưu thành công thông tin lớp, tiếp tục lưu lịch học
          this.saveLichHocAfterClassSave();
        }
        else {
          swal('Cảnh báo!', response.Status, 'warning');
        }
      });
  }


  // Sau khi lưu thành công thông tin lớp, tiếp tục lưu lịch học
  private saveLichHocAfterClassSave(): void {
    // Kiểm tra xem có lịch học nào được thiết lập không
    const hasSchedule = this.weeklySchedule.some(day =>
      day.isActive && day.schedules.length > 0
    );

    if (!hasSchedule) {
      // Nếu không có lịch học, chỉ emit thông báo lưu thành công
      this.save.emit(this.doituongSelect);
      swal('Thành công!', 'Lưu thông tin lớp học thành công!', 'success');
      return;
    }


    const lichHocData = [];
    this.weeklySchedule.forEach(day => {
      if (day.isActive && day.schedules.length > 0) {
        day.schedules.forEach(schedule => {
          // Chỉ lưu những schedule có đủ thông tin cơ bản
          if (schedule.tuGio && schedule.denGio) {
            // Convert thời gian thành DateTime
            const today = new Date();
            const tuNgay = new Date(today.getFullYear(), today.getMonth(), today.getDate(),
              schedule.tuGio.getHours(), schedule.tuGio.getMinutes(), 0);
            const denNgay = new Date(today.getFullYear(), today.getMonth(), today.getDate(),
              schedule.denGio.getHours(), schedule.denGio.getMinutes(), 0);

            lichHocData.push({
              Id: schedule.Id,
              LopId: this.doituongSelect.Id,
              Thu: day.dayId,
              TuNgay: tuNgay,
              DenNgay: denNgay,
              GiaTien1Ca: schedule.giaTien1Ca || null, // Thêm field mới
              PhongHocId: schedule.phongHocId,
              GiaoVienId: schedule.giaoVienId,
              GhiChu: schedule.ghiChu || '',
              Username: this.currentUser.user_name
            });
          }
        });
      }
    });


    if (lichHocData.length === 0) {
      // Nếu không có lịch học hợp lệ, chỉ emit thông báo lưu thành công
      this.save.emit(this.doituongSelect);
      swal('Thành công!', 'Lưu thông tin lớp học thành công!', 'success');
      return;
    }

    // Lưu lịch học
    this.repo.postRequest("api/hocvien/lichhocsave", lichHocData)
      .subscribe(response => {
        if (response.Status === "OK" || response.status === "OK") {
          this.save.emit(this.doituongSelect);
          swal('Thành công!', 'Lưu thông tin lớp học và lịch học thành công!', 'success');
        } else {
          // Refresh ca học list sau khi lưu lịch học
          this.availableCaHocs = []; // Clear cache
          this.loadAvailableCaHocs(); // Reload

          // Nếu lưu lịch học thất bại, vẫn thông báo lưu lớp thành công nhưng cảnh báo về lịch học
          this.save.emit(this.doituongSelect);
          swal('Cảnh báo!', `Lưu thông tin lớp học thành công nhưng có lỗi khi lưu lịch học: ${response.status}`, 'warning');
        }
      }, error => {
        // Xử lý lỗi khi call API lịch học
        console.error('Error saving schedule:', error);
        this.save.emit(this.doituongSelect);
        swal('Cảnh báo!', 'Lưu thông tin lớp học thành công nhưng có lỗi khi lưu lịch học!', 'warning');
      });
  }
  // Phương thức xóa tất cả schedules của một ngày
  private clearDaySchedules(daySchedule: any): void {
    daySchedule.schedules = [];
    daySchedule.isActive = false;
  }
  // Thêm method để kiểm tra xem có thể xóa không
  canDeleteSchedule(schedule: any): boolean {
    // Có thể thêm logic kiểm tra quyền xóa ở đây
    return this.quyen_xoa;
  }
  // Thêm phương thức xóa lịch học với xác nhận
  // Phương thức xóa lịch học với xác nhận
  deleteScheduleRowWithConfirm(daySchedule: any, schedule: any, scheduleIndex: number): void {
    swal({
      title: 'Bạn muốn xóa ca học này phải không?',
      text: `Ca học ${daySchedule.dayName} từ ${schedule.tuGio ? schedule.tuGio.toTimeString().substring(0, 5) : ''} đến ${schedule.denGio ? schedule.denGio.toTimeString().substring(0, 5) : ''}`,
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          // Nếu có ID (đã lưu trong database), gọi API xóa
          if (schedule.Id && schedule.Id !== null) {
            this.deleteScheduleFromDatabase(schedule.Id, daySchedule, scheduleIndex);
          } else {
            // Nếu chưa lưu, chỉ xóa khỏi array
            this.removeScheduleFromArray(daySchedule, scheduleIndex);
            swal('Đã xóa!', 'Ca học đã được xóa khỏi danh sách!', 'success');
          }
        }
      });
  }

  // Phương thức xóa lịch học từ database
  private deleteScheduleFromDatabase(scheduleId: any, daySchedule: any, scheduleIndex: number): void {
    this.repo.postRequest('api/lichhoc/delete/', {
      IdGuid: scheduleId,
      PhanHeId: KhoaHocs_KhoaHoc.id,
      UserName: this.currentUser.user_name
    }).subscribe(
      response => {
        if (response === "OK") {
          // **FIX: Xóa và rebuild toàn bộ weeklySchedule**
          this.removeScheduleFromArray(daySchedule, scheduleIndex);

          // Reload lại data từ server sau khi xóa
          if (this.doituongSelect.Id) {
            this.repo.postRequest("api/daotao/getthongtinhoso/", {
              id: this.doituongSelect.Id,
              status: 0
            }).subscribe(response => {
              if (response.LichHocs && response.LichHocs.length > 0) {
                this.loadLichHocFromResponse(response.LichHocs);
              } else {
                // Nếu không còn lịch học nào, reset
                this.weeklySchedule.forEach(day => {
                  if (day.dayId === daySchedule.dayId) {
                    day.schedules = [];
                    if (day.schedules.length === 0) {
                      day.isActive = false;
                    }
                  }
                });
                // Force rebuild
                this.weeklySchedule = [...this.weeklySchedule];
              }

              // Refresh ca học list
              this.refreshCaHocList();
            });
          }

          swal('Đã xóa!', 'Ca học đã được xóa thành công!', 'success');
        } else {
          swal('Cảnh báo!', response, 'warning');
        }
      },
      error => {
        swal('Lỗi!', 'Có lỗi xảy ra khi xóa ca học!', 'error');
        console.error('Delete schedule error:', error);
      }
    );
  }

  // Phương thức xóa schedule khỏi array
  private removeScheduleFromArray(daySchedule: any, scheduleIndex: number): void {
    // **FIX 1: Xóa bằng filter thay vì splice để tạo array mới**
    const scheduleToRemove = daySchedule.schedules[scheduleIndex];
    daySchedule.schedules = daySchedule.schedules.filter((s, idx) => idx !== scheduleIndex);

    // Nếu không còn schedule nào, set isActive = false
    if (daySchedule.schedules.length === 0) {
      daySchedule.isActive = false;
    }

    // **FIX 2: Rebuild toàn bộ weeklySchedule với object mới**
    this.weeklySchedule = this.weeklySchedule.map(day => {
      if (day.dayId === daySchedule.dayId) {
        return {
          ...day,
          schedules: [...day.schedules],
          isActive: day.schedules.length > 0
        };
      }
      return { ...day };
    });

    // **FIX 3: Rebuild ca học list ngay lập tức**
    setTimeout(() => {
      this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
    }, 50);
  }

  // Thêm method trackBy cho performance tốt hơn
  trackByScheduleIndex(index: number, item: any): any {
    return item.Id || index;
  }

  trackByDayId(index: number, item: any): any {
    return item.dayId;
  }
  // Cập nhật phương thức saveLichHoc để tránh trùng lặp
  saveLichHoc(): void {
    if (!this.doituongSelect.Id) {
      swal('Cảnh báo!', 'Vui lòng lưu thông tin lớp học trước khi thiết lập lịch học!', 'warning');
      return;
    }

    const lichHocData = [];
    this.weeklySchedule.forEach(day => {
      if (day.isActive && day.schedules.length > 0) {
        day.schedules.forEach(schedule => {
          if (schedule.tuGio && schedule.denGio) {
            lichHocData.push({
              LopId: this.doituongSelect.Id,
              Thu: day.dayId,
              TuGio: schedule.tuGio,
              DenGio: schedule.denGio,
              PhongHocId: schedule.phongHocId,
              GiaoVienId: schedule.giaoVienId,
              GhiChu: schedule.ghiChu || ''
            });
          }
        });
      }
    });

    if (lichHocData.length === 0) {
      swal('Cảnh báo!', 'Vui lòng thiết lập ít nhất một ca học với đầy đủ thông tin thời gian!', 'warning');
      return;
    }

    this.repo.postRequest("api/hocvien/lichhocsave", lichHocData)
      .subscribe(response => {
        if (response.Status === "OK") {
          swal('Thành công!', 'Lưu lịch học thành công!', 'success');
        } else {
          swal('Lỗi!', response.Status, 'error');
        }
      }, error => {
        console.error('Error saving schedule:', error);
        swal('Lỗi!', 'Có lỗi xảy ra khi lưu lịch học!', 'error');
      });
  }



  changeCachGuiThongBao($event: any) {
    console.log($event);
    if (typeof $event === "undefined") {
      this.doituongSelect.CachGuiThongBao = null;
      this.doituongSelect.DieuKienGui = null;
    } else {
      this.doituongSelect.CachGuiThongBao = $event.id;
      this.doituongSelect.DieuKienGui = null; // Reset value when changing method
    }
  }

  getLabelDieuKienGui(): string {
    if (this.doituongSelect.CachGuiThongBao === 1) {
      return 'Ngày gửi';
    } else if (this.doituongSelect.CachGuiThongBao === 2) {
      return 'Số buổi còn lại';
    } else if (this.doituongSelect.CachGuiThongBao === 3) {
      return 'Ngày còn lại';
    }
    return 'Điều kiện gửi';
  }

  getPlaceholderDieuKienGui(): string {
    if (this.doituongSelect.CachGuiThongBao === 1) {
      return 'Nhập ngày gửi';
    } else if (this.doituongSelect.CachGuiThongBao === 2) {
      return 'Nhập số buổi còn lại';
    } else if (this.doituongSelect.CachGuiThongBao === 3) {
      return 'Nhập số ngày còn lại';
    }
    return 'Nhập điều kiện gửi';
  }


  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  adddata_danhsachlichhoc() {
    if (this.doituongSelect.Id !== null) {
      this.dtedslichhocedit.loadDataInit(this.doituongSelect.Id, KhoaHocs_KhoaHoc.id);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDanhSachLichHoc.open();
    }
    else {
      swal('Lỗi!', 'Phải thêm lớp học trước khi thêm lịch học!.', 'error');
      return;
    }

  }
  save_danhsachlichhoc(doituong: any) {
    this.mdDanhSachLichHoc.close();
  }

  // Add these methods:
  private scheduleChangeTimeout: any;
  // Cập nhật method onDayActiveChange để refresh ca học
  onDayActiveChange(daySchedule: any): void {
    if (!daySchedule.isActive) {
      daySchedule.schedules = [];
    } else if (daySchedule.schedules.length === 0) {
      this.addScheduleRow(daySchedule);
    }

    // Refresh ca học list khi thay đổi lịch học (với delay để tránh gọi liên tục)
    clearTimeout(this.scheduleChangeTimeout);
    this.scheduleChangeTimeout = setTimeout(() => {
      this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
    }, 500);
  }


  // Cập nhật addScheduleRow và removeScheduleRow
  addScheduleRow(daySchedule: any): void {
    daySchedule.schedules.push({
      Id: null,
      tuGio: null,
      denGio: null,
      giaTien1Ca: null, // Thêm field mới
      phongHocId: null,
      giaoVienId: null,
      ghiChu: ''
    });

    // Refresh ca học list với delay
    clearTimeout(this.scheduleChangeTimeout);
    this.scheduleChangeTimeout = setTimeout(() => {
      this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
    }, 500);
  }


  removeScheduleRow(daySchedule: any, index: number): void {
    daySchedule.schedules.splice(index, 1);

    // Refresh ca học list với delay
    clearTimeout(this.scheduleChangeTimeout);
    this.scheduleChangeTimeout = setTimeout(() => {
      this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
    }, 500);
  }

 
  loadHocVienData(): void {
    if (!this.dviid || !this.doituongSelect.Id) {
      console.log('Missing donviid or lopid for loading student data');
      this.isLoadingHocVien = false;
      return;
    }
    $('#loading').show();
    this.repo.postRequest("api/hocvien/hocvientheolop", {
      donviid: this.dviid,
      lopid: this.doituongSelect.Id
    })
      .subscribe(response => {
        $('#loading').hide();
        this.isLoadingHocVien = false;
        console.log('API Response:', response); // Debug log

        if (response && response.success && response.data) {
          // Map API response to component data structure
          let dateNgayVaoLop = this.doituongSelect.TuNgay;
          if (dateNgayVaoLop = null)
            dateNgayVaoLop = new Date();
          this.danhSachHocVien = response.data.map(student => {
            // Debug: Log the caHocIds data
            console.log('Student:', student.tenHocVien, 'caHocIds:', student.caHocIds);

            // Ensure caHocIds is always an array of strings
            let caHocIds = [];
            if (student.caHocIds) {
              if (Array.isArray(student.caHocIds)) {
                caHocIds = student.caHocIds.map(id => id?.toString());
              } else if (typeof student.caHocIds === 'string') {
                // If it's a comma-separated string, split it
                caHocIds = student.caHocIds.split(',').map(id => id.trim());
              } else {
                caHocIds = [student.caHocIds.toString()];
              }
            }

            console.log('Processed caHocIds:', caHocIds);
            // Improved IsCoDinhThang mapping with more robust checking
            let isCoDinhThang = false;
            if (student.IsCoDinhThang !== null && student.IsCoDinhThang !== undefined) {
              // Handle different data types that might come from API
              if (typeof student.IsCoDinhThang === 'boolean') {
                isCoDinhThang = student.IsCoDinhThang;
              } else if (typeof student.IsCoDinhThang === 'number') {
                isCoDinhThang = student.IsCoDinhThang === 1;
              } else if (typeof student.IsCoDinhThang === 'string') {
                isCoDinhThang = student.IsCoDinhThang === '1' || student.IsCoDinhThang.toLowerCase() === 'true';
              }
            }

            // Thêm logic xử lý cho IsBoTinhHocPhi
            let isBoTinhHocPhi = false;
            if (student.IsBoTinhHocPhi !== null && student.IsBoTinhHocPhi !== undefined) {
              if (typeof student.IsBoTinhHocPhi === 'boolean') {
                isBoTinhHocPhi = student.IsBoTinhHocPhi;
              } else if (typeof student.IsBoTinhHocPhi === 'number') {
                isBoTinhHocPhi = student.IsBoTinhHocPhi === 1;
              } else if (typeof student.IsBoTinhHocPhi === 'string') {
                isBoTinhHocPhi = student.IsBoTinhHocPhi === '1' || student.IsBoTinhHocPhi.toLowerCase() === 'true';
              }
            }

            return {
              id: student.id,
              nhanSuId: student.nhanSuId,
              lopId: student.lopId,
              tenHocVien: student.tenHocVien,
              ngayVaoLop: student.ngayVaoLop ? new Date(student.ngayVaoLop) : dateNgayVaoLop,
              hocPhi: student.hocPhi,
              chiPhiDiLai: student.chiPhiDiLai,
              isCoDinhThang: isCoDinhThang,
              isBoTinhHocPhi: isBoTinhHocPhi, // Thêm field mới
              caHocIds: caHocIds,
              trangThai: student.trangThai,
              created: student.created,
              createdBy: student.createdBy,
              modified: student.modified,
              modifiedBy: student.modifiedBy
            };
          });

          console.log('Final student data:', this.danhSachHocVien);
          console.log('Available ca hocs:', this.getAvailableCaHocs());

          // Force change detection after data loading
          setTimeout(() => {
            // Trigger Angular change detection
            if (this.danhSachHocVien.length > 0) {
              console.log('Data loaded, triggering change detection');
            }
          }, 100);
        } else {
          this.danhSachHocVien = [];
          console.log('No student data found for this class');
        }
      }, error => {
        console.error('Error loading student data:', error);
        this.danhSachHocVien = [];
      });
  }

  // Thêm method để lưu dữ liệu học sinh
  saveHocVienData(): void {
    if (!this.doituongSelect.Id) {
      swal('Cảnh báo!', 'Vui lòng lưu thông tin lớp học trước khi lưu danh sách học sinh!', 'warning');
      return;
    }

    // Validate dữ liệu học sinh
    const invalidStudents = this.danhSachHocVien.filter(hv =>
      !hv.tenHocVien || hv.tenHocVien.trim() === ''
    );

    if (invalidStudents.length > 0) {
      swal('Cảnh báo!', 'Vui lòng nhập tên cho tất cả học sinh!', 'warning');
      return;
    }

    // Prepare data for API
    const studentData = this.danhSachHocVien.map(hv => ({
      Id: hv.id,
      NhanSuId: hv.nhanSuId,
      LopId: this.doituongSelect.Id,
      TenHocVien: hv.tenHocVien,
      NgayVaoLop: hv.ngayVaoLop,
      IsCoDinhThang: hv.isCoDinhThang || false,
      IsBoTinhHocPhi: hv.isBoTinhHocPhi || false, // Thêm field mới
      HocPhi: hv.hocPhi || 0,
      ChiPhiDiLai_CT: hv.chiPhiDiLai || 0,
      CaHocIds: hv.caHocIds || [],
      TrangThai: hv.trangThai || 1,
      DonViId: this.dviid,
      Username: this.currentUser?.user_name
    }));

    this.repo.postRequest("api/hocvien/savehocvientheolop", {
      LopId: this.doituongSelect.Id,
      DonViId: this.dviid,
      HocViens: studentData,
      Username: this.currentUser?.user_name
    })
      .subscribe(response => {
        if (response && response.success) {
          swal('Thành công!', 'Lưu danh sách học sinh thành công!', 'success');
          // Reload data to get updated IDs
          this.loadHocVienData();
        } else {
          swal('Lỗi!', response.message || 'Có lỗi xảy ra khi lưu danh sách học sinh!', 'error');
        }
      }, error => {
        console.error('Error saving student data:', error);
        swal('Lỗi!', 'Có lỗi xảy ra khi lưu danh sách học sinh!', 'error');
      });
  }
  removeHocVien(index: number): void {
    this.danhSachHocVien.splice(index, 1);
  }

  // Thay đổi hàm này để không gọi API trực tiếp
  getAvailableCaHocs(): any[] {
    // Chỉ trả về dữ liệu đã cache, không gọi API
    return this.availableCaHocs || [];
  }
  // Thêm hàm riêng để load data
  loadAvailableCaHocs(): void {
    // Chỉ gọi API khi có đủ thông tin và chưa load
    if (this.dviid && this.doituongSelect.Id && this.availableCaHocs.length === 0) {
      this.repo.postRequest("api/hocvien/cahoclop", {
        donviid: this.dviid,
        lopid: this.doituongSelect.Id
      })
        .subscribe(response => {
          if (response && response.data) {
            this.availableCaHocs = response.data;
          } else {
            // Fallback to building from weeklySchedule
            this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
          }
        }, error => {
          console.error('Error fetching ca hoc data:', error);
          // Fallback to existing logic if API call fails
          this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
        });
    } else if (!this.dviid || !this.doituongSelect.Id) {
      // Fallback to building from weeklySchedule if donviid or lopid not available
      this.availableCaHocs = this.buildCaHocsFromWeeklySchedule();
    }
  }
  // Kiểm tra xem ca học có được chọn không
  
  isCaHocSelected(caHocIds: string[], caHocId: string): boolean {
    if (!caHocIds || !Array.isArray(caHocIds) || !caHocId) {
      return false;
    }

    // Debug log
    //console.log('Checking caHocId:', caHocId, 'in array:', caHocIds);

    // Convert both to uppercase string for GUID comparison
    const caHocIdUpper = caHocId.toString().toUpperCase();
    const found = caHocIds.some(id => {
      const idUpper = id?.toString().toUpperCase();
      return idUpper === caHocIdUpper;
    });

   // console.log('Found:', found);
    return found;
  }

  // Toggle selection của ca học
  toggleCaHocSelection(hocvien: any, caHocId: string, event: any): void {
    // Khởi tạo array nếu chưa có
    if (!hocvien.caHocIds || !Array.isArray(hocvien.caHocIds)) {
      hocvien.caHocIds = [];
    }

    const isChecked = event.target.checked;
    const index = hocvien.caHocIds.indexOf(caHocId);

    if (isChecked && index === -1) {
      // Thêm ca học vào danh sách đã chọn
      hocvien.caHocIds.push(caHocId);
    } else if (!isChecked && index > -1) {
      // Xóa ca học khỏi danh sách đã chọn
      hocvien.caHocIds.splice(index, 1);
    }
  }
  // Lấy tên các ca học đã chọn để hiển thị (optional - nếu muốn hiển thị summary)
  getSelectedCaHocNames(caHocIds: string[]): string[] {
    if (!caHocIds || caHocIds.length === 0) {
      return [];
    }

    const availableCaHocs = this.getAvailableCaHocs();
    return caHocIds
      .map(id => {
        const caHoc = availableCaHocs.find(item => item.Id === id);
        return caHoc ? caHoc.ten : null;
      })
      .filter(name => name !== null);
  }
  // Helper method to build ca hocs from weekly schedule (existing logic)
  private buildCaHocsFromWeeklySchedule(): any[] {
    const caHocs = [];
    this.weeklySchedule.forEach(day => {
      if (day.isActive && day.schedules.length > 0) {
        day.schedules.forEach((schedule, index) => {
          const tuGioStr = schedule.tuGio ? schedule.tuGio.toTimeString().substring(0, 5) : '';
          const denGioStr = schedule.denGio ? schedule.denGio.toTimeString().substring(0, 5) : '';

          // Chỉ thêm vào nếu có đủ thông tin thời gian
          if (tuGioStr && denGioStr) {
            caHocs.push({
              Id: `${day.dayId}_${index}`,
              ten: `${day.dayName} (${tuGioStr} - ${denGioStr})`
            });
          }
        });
      }
    });
    return caHocs;
  }
  refreshCaHocList(): void {
    this.availableCaHocs = [];
    this.loadAvailableCaHocs();
  }

  // Also add method to load existing schedule data:
  loadLichHoc(): void {
    if (this.doituongSelect.Id) {
      this.repo.postRequest("api/daotao/lichhoclop", { Status: this.doituongSelect.Id })
        .subscribe(response => {
          if (response.Status && response.Data) {
            // Process and populate weeklySchedule with existing data
            this.populateWeeklySchedule(response.Data);
          }
        });
    }
  }
  
 
  populateWeeklySchedule(data: any[]): void {
    // Reset schedule
    this.weeklySchedule.forEach(day => {
      day.isActive = false;
      day.schedules = [];
    });

    // Group data by day
    data.forEach(item => {
      const day = this.weeklySchedule.find(d => d.dayId === item.Thu);
      if (day) {
        day.isActive = true;
        day.schedules.push({
          Id: item.Id,
          tuGio: item.TuGio ? new Date(`1970-01-01T${item.TuGio}`) : null,
          denGio: item.DenGio ? new Date(`1970-01-01T${item.DenGio}`) : null,
          giaTien1Ca: item.giaTien1Ca || null, // Thêm field mới
          phongHocId: item.PhongHocId,
          giaoVienId: item.GiaoVienId,
          ghiChu: item.GhiChu
        });
      }
    });
    console.log(this.weeklySchedule); 

  }
  isSavingSchedule: boolean = false;
  // Method để lưu riêng lịch học
  saveLichHocOnly(): void {
    if (!this.doituongSelect.Id) {
      swal('Cảnh báo!', 'Vui lòng lưu thông tin lớp học trước khi thiết lập lịch học!', 'warning');
      return;
    }

    // Kiểm tra xem có lịch học nào được thiết lập không
    const hasSchedule = this.weeklySchedule.some(day =>
      day.isActive && day.schedules.length > 0
    );

    if (!hasSchedule) {
      swal('Cảnh báo!', 'Vui lòng thiết lập ít nhất một ca học!', 'warning');
      return;
    }

    // Validate thời gian của các schedule
    let hasValidSchedule = false;
    let hasInvalidSchedule = false;

    this.weeklySchedule.forEach(day => {
      if (day.isActive && day.schedules.length > 0) {
        day.schedules.forEach(schedule => {
          if (schedule.tuGio && schedule.denGio) {
            hasValidSchedule = true;
          } else {
            hasInvalidSchedule = true;
          }
        });
      }
    });

    if (!hasValidSchedule) {
      swal('Cảnh báo!', 'Vui lòng thiết lập thời gian cho ít nhất một ca học!', 'warning');
      return;
    }

    if (hasInvalidSchedule) {
      swal({
        title: 'Có ca học chưa đầy đủ thông tin!',
        text: 'Một số ca học chưa có thời gian. Bạn có muốn tiếp tục lưu các ca học hợp lệ?',
        icon: "warning",
        buttons: {
          cancel: {
            text: 'Hủy bỏ',
            value: false,
            visible: true,
          },
          confirm: {
            text: 'Tiếp tục',
            value: true,
            visible: true,
            className: "bg-primary",
            closeModal: true
          }
        }
      }).then(willContinue => {
        if (willContinue) {
          this.performSaveLichHoc();
        }
      });
    } else {
      this.performSaveLichHoc();
    }
  }

  // Method thực hiện lưu lịch học
  private performSaveLichHoc(): void {
    this.isSavingSchedule = true;

    const lichHocData = [];
    this.weeklySchedule.forEach(day => {
      if (day.isActive && day.schedules.length > 0) {
        day.schedules.forEach(schedule => {
          // Chỉ lưu những schedule có đủ thông tin thời gian
          if (schedule.tuGio && schedule.denGio) {
            // Convert thời gian thành DateTime
            const today = new Date();
            const tuNgay = new Date(today.getFullYear(), today.getMonth(), today.getDate(),
              schedule.tuGio.getHours(), schedule.tuGio.getMinutes(), 0);
            const denNgay = new Date(today.getFullYear(), today.getMonth(), today.getDate(),
              schedule.denGio.getHours(), schedule.denGio.getMinutes(), 0);

            lichHocData.push({
              Id: schedule.Id,
              LopId: this.doituongSelect.Id,
              Thu: day.dayId,
              TuNgay: tuNgay,
              DenNgay: denNgay,
              GiaTien1Ca: schedule.giaTien1Ca || null, // Thêm field mới
              PhongHocId: schedule.phongHocId,
              GiaoVienId: schedule.giaoVienId,
              GhiChu: schedule.ghiChu || '',
              Username: this.currentUser.user_name
            });
          }
        });
      }
    });

    if (lichHocData.length === 0) {
      this.isSavingSchedule = false;
      swal('Cảnh báo!', 'Không có ca học hợp lệ để lưu!', 'warning');
      return;
    }

    // Lưu lịch học
    this.repo.postRequest("api/hocvien/lichhocsave", lichHocData)
      .subscribe(response => {
        this.isSavingSchedule = false;

        if (response.Status === "OK" || response.status === "OK") {
          // Refresh danh sách ca học sau khi lưu thành công
          this.refreshCaHocList();
          this.save.emit(this.doituongSelect);
          swal('Thành công!', 'Lưu lịch học thành công!', 'success');
        } else {
          swal('Lỗi!', response.status || response.Status || 'Có lỗi xảy ra khi lưu lịch học', 'error');
        }
      }, error => {
        this.isSavingSchedule = false;
        console.error('Error saving schedule:', error);
        swal('Lỗi!', 'Có lỗi xảy ra khi lưu lịch học!', 'error');
      });
  }


}

